module.exports = __webpack_public_path__ + "img/configmsg.60394812.svg";